
import { Box, styled, useTheme } from "@mui/material";
import { Ico_Warning } from "@sagecentral/core-ui";
import { NavLink } from "react-router-dom";

const TabLinkStyle = styled(NavLink)(({ theme }) => ({
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '10px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#333333',
    textTransform: 'uppercase',
    textDecoration: 'none',

    '&.active': {
        color: theme.palette.secondary.main,
        fontWeight: 600
    }
}));

const TabLinkContentBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center'
});

export interface IPageTabLinkProps {
    value: number;
    text?: string;
    href?: string;
    selected?: boolean;
    hasAlert?: boolean;    
}

const PageTabLink = (props: IPageTabLinkProps) => {
    const { href, text, hasAlert } = props;
    const theme = useTheme();
    return (
        <TabLinkStyle
            to={href || ''}
        >
            <TabLinkContentBox>
                { text }
                { hasAlert ? 
                    <Ico_Warning
                        sx={{
                            width: '20px',
                            height: '20px',
                            marginLeft: '5px'
                        }}
                        htmlColor={theme.palette.error.main}
                    />
                : null }
            </TabLinkContentBox>
        </TabLinkStyle>
    );
};

export default PageTabLink;